'use client'

import { Emoji } from '@/components/between-sessions/Emoji'

// Real quotes pulled from the between-sessions-semester-check-in
// self_assessment responses. All quotes verbatim. Gillian-related
// quotes filtered out (Gillian is leaving the team).
//
// IMPORTANT (Cherry): confirm consent with each named member before
// this ships to the public landing. Members submitted these in an
// internal check-in survey, not for public display. A quick email or
// Slack DM per member is the responsible path.
const TESTIMONIALS: {
  quote: string
  name: string
  tier: string
  cohort: string
}[] = [
  {
    quote:
      'I get a lot from Between Sessions. I love supervision and all the groups, and the community education is wonderful.',
    name: 'Angela',
    tier: 'Complete',
    cohort: '26 winter',
  },
  {
    quote:
      'The supportive supervision environment, opportunities for professional growth, and connection with other clinicians have been valuable.',
    name: 'Elaheh',
    tier: 'Complete',
    cohort: '26 winter',
  },
  {
    quote:
      'Charlotte gives incredible insight and feedback; her ability to break down issues and present ways to approach them is truly excellent.',
    name: 'Jan',
    tier: 'Complete',
    cohort: '26 winter',
  },
  {
    quote:
      'Knowledgeable and approachable supervisors — I highly look up to them.',
    name: 'Ghazaleh',
    tier: 'Complete+',
    cohort: '26 winter',
  },
  {
    quote: 'The community support, supervision, and access to resources.',
    name: 'Keri',
    tier: 'Complete',
    cohort: '26 winter',
  },
  {
    quote:
      'Being able to participate in the things that work for me. Having access to various types of supervision and having a network.',
    name: 'Rachel',
    tier: 'Complete',
    cohort: '26 winter',
  },
  {
    quote:
      'Tanya is really compassionate and really takes her time to work through concerns and issues.',
    name: 'Brooklyn',
    tier: 'Complete',
    cohort: '26 winter',
  },
  {
    quote:
      'The dashboard and weekly reminders are amazing — as are the built-in trackers.',
    name: 'Danielle',
    tier: 'Complete',
    cohort: '26 spring',
  },
  {
    quote: 'Working with my dyad supervisor Shauna. She’s very helpful.',
    name: 'Lina',
    tier: 'Complete',
    cohort: '26 spring',
  },
]

export function LandingTestimonial() {
  return (
    <section className="px-6 py-24 sm:py-28 bg-white border-y border-[#ececec]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.22em] text-bs-secondary-700 font-display font-semibold mb-4">
            From our members
          </p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight text-gray-900 mb-4">
            In their{' '}
            <span className="italic text-bs-secondary-500">own words</span>.
          </h2>
          <p className="text-[15px] text-gray-600 leading-relaxed">
            Real feedback from active BES members.
          </p>
        </div>

        {/* Testimonial grid — 3 cols on desktop, 2 on tablet, 1 on
            mobile. Each card is a full quote + attribution. Some cards
            will naturally be taller than others because quote lengths
            vary; that's fine and adds visual rhythm. */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <blockquote
              key={i}
              className="rounded-[1.4rem] border border-[#ececec] bg-[#faf9f6] p-6 sm:p-7 flex flex-col hover:-translate-y-1 hover:shadow-[0_16px_32px_-16px_rgba(20,20,20,0.18)] hover:border-bs-secondary-200 transition-all duration-300"
            >
              {/* Small lavender quote icon at the top */}
              <div className="w-8 h-8 rounded-full bg-white border border-bs-secondary-100 flex items-center justify-center text-bs-secondary-500 mb-4 shadow-[0_4px_10px_-4px_rgba(20,20,20,0.1)]">
                <Emoji name="fluent-emoji-high-contrast:speech-balloon" size={16} />
              </div>

              <p className="text-[15px] text-gray-800 leading-relaxed font-display italic mb-5 flex-1">
                <span className="text-bs-secondary-500 not-italic">&ldquo;</span>
                {t.quote}
                <span className="text-bs-secondary-500 not-italic">&rdquo;</span>
              </p>

              <footer className="mt-auto pt-4 border-t border-[#ececec]">
                <p className="text-[13px] font-display font-semibold text-gray-900 leading-tight">
                  {t.name}
                </p>
                <p className="text-[11px] text-gray-500 font-display font-medium mt-0.5">
                  {t.tier} · {t.cohort} cohort
                </p>
              </footer>
            </blockquote>
          ))}
        </div>

      </div>
    </section>
  )
}
